export const formatBytes = (n: number) => {
    if (!n && n !== 0) return "";
    const units = ["Б", "КБ", "МБ", "ГБ", "ТБ"];
    let i = 0;
    let v = n;
    while (v >= 1024 && i < units.length - 1) {
        v /= 1024;
        i++;
    }
    return `${v.toFixed(1)} ${units[i]}`;
};

export const onlyHexAndDash = (s: string) => s.replace(/[^a-zA-Z0-9]/g, "");

export const groupEvery4 = (s: string) =>
    s
        .replace(/[^a-zA-Z0-9]/g, "")
        .match(/.{1,4}/g)
        ?.join("-")
        .toLowerCase() ?? "";

export const cleanDash = (s: string) => s.replace(/-/g, "");
